import { useCallback, useMemo } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { parseView, viewToParams, type BoardView } from './view'

export type UpdateView = (update: (view: BoardView) => BoardView) => void
export function useBoardView(): [BoardView, UpdateView] {
  const [params, setParams] = useSearchParams()
  const { state } = useLocation()
  const view = useMemo(() => parseView(params), [params])
  const update = useCallback<UpdateView>(fn => setParams(prev => {
    const next = viewToParams(fn(parseView(prev)))
    const peek = prev.get('peek')
    if (peek) next.set('peek', peek)
    return next
  }, { replace: true, state }), [setParams, state])
  return [view, update]
}
